module.exports = __webpack_public_path__ + "img/photo.459cd5f3.png";